import state from "@/store/modules/itensNF/state";
import actions from "@/store/modules/itensNF/actions";
import mutations from "@/store/modules/itensNF/mutations";
import getters from "@/store/modules/itensNF/getters";

export default {
    state,
    actions,
    mutations,
    getters
}